/*****************************
 *   Site Navigation Styles
 *****************************
 */

function shopNowHoverIn() {
    if (window.innerWidth <= 900) return;

    $('.dropdown').css('display', 'inherit');
}

function shopNowHoverOut() {
    $('.dropdown').css('display', 'none');
}

function styleDropdownContent(el) {
    el.css('background-color', 'red');
}

function setContentImages(el) {
    var imgSrc = null,
        textContent = null;
    var fullClassStr = el.attr('class');
    var imageType = fullClassStr.slice(fullClassStr.indexOf('content-img'));
    switch (imageType) {
        case 'content-img-1':
            imgSrc = '/assets/images/shop-now/A69A3248-min.jpg';
            textContent = 'Clubs';
            break;
        case 'content-img-2':
            imgSrc = '/assets/images/shop-now/9G2A9629-min.jpg';
            textContent = 'Clothing & Shoes';
            break;
        case 'content-img-3':
            imgSrc =
                '/assets/images/shop-now/82067703_206895540493736_6353987819450785401_n-min.jpg';
            textContent = 'Balls & Accessories';
            break;
        case 'content-img-4':
            imgSrc = '/assets/images/shop-now/watch-min.jpg';
            textContent = 'GPS, Bags & Equipment';
            break;
        default:
            break;
    }
    if (!imgSrc || !textContent) return;
    var imgEl = $('<img>', {
        css: {
            borderRadius: 20
        }
    });
    imgEl.attr('src', imgSrc);
    var titleEl = $('<h3>', { class: 'dropdown-content-title' });
    titleEl.text(textContent);
    el.append(imgEl);
    el.append(titleEl);
}

function shopNowClick(el) {
    var dropdownEl = $(el.target).parent('.dropdown-content');
    if (!dropdownEl.length) return;
    var fullClassStr = dropdownEl.attr('class');
    var imageType = fullClassStr.slice(fullClassStr.indexOf('content-img'));
    switch (imageType) {
        case 'content-img-1':
            url =
                'https://www.americangolf.co.uk/golf-clubs/?utm_source=Blog&utm_medium=Shop_Link&utm_campaign=Clubs';
            break;
        case 'content-img-2':
            url =
                'https://www.americangolf.co.uk/clothing-shoes/?utm_source=Blog&utm_medium=Shop_Link&utm_campaign=Clothing_Shoes';
            break;
        case 'content-img-3':
            url =
                'https://www.americangolf.co.uk/balls-accessories/?utm_source=Blog&utm_medium=Shop_Link&utm_campaign=Balls_Accessories';
            break;
        case 'content-img-4':
            url =
                'https://www.americangolf.co.uk/gps-bags-equipment/?utm_source=Blog&utm_medium=Shop_Link&utm_campaign=GPS_Equipment';
            break;
        default:
            break;
    }
    window.location.href = url;
}

function responsiveShopNowContent(e) {
    var innerWidth = null;
    if (!e.target) {
        innerWidth = e.innerWidth;
    } else {
        innerWidth = e.target.innerWidth;
    }

    if (innerWidth <= 1340) {
        $('.content-img-4').css('display', 'none');
    } else if (innerWidth > 1340) {
        $('.content-img-4').css('display', 'inline-block');
    }

    if (innerWidth <= 1040) {
        $('.content-img-3').css('display', 'none');
    } else if (innerWidth > 1040) {
        $('.content-img-3').css('display', 'inline-block');
    }

    if (innerWidth <= 900) {
        $('.dropdown').css('display', 'none');
    }
}

$(document).ready(function() {
    var shopNowEl = $('li.nav-shop-now');
    var dropdownContent1El = $('<div>', {
        class: 'dropdown-content content-img-1',
        css: {
            cursor: 'pointer'
        }
    });
    var dropdownContent2El = $('<div>', {
        class: 'dropdown-content content-img-2',
        css: {
            cursor: 'pointer'
        }
    });
    var dropdownContent3El = $('<div>', {
        class: 'dropdown-content content-img-3',
        css: {
            cursor: 'pointer'
        }
    });
    var dropdownContent4El = $('<div>', {
        class: 'dropdown-content content-img-4',
        css: {
            cursor: 'pointer'
        }
    });
    setContentImages(dropdownContent1El);
    setContentImages(dropdownContent2El);
    setContentImages(dropdownContent3El);
    setContentImages(dropdownContent4El);
    var dropdownEl = $('<div>', {
        class: 'dropdown',
        css: {
            display: 'none'
        }
    });
    dropdownEl.append(dropdownContent1El);
    dropdownEl.append(dropdownContent2El);
    dropdownEl.append(dropdownContent3El);
    dropdownEl.append(dropdownContent4El);
    shopNowEl.append(dropdownEl);
    shopNowEl.mouseenter(shopNowHoverIn).mouseleave(shopNowHoverOut);
    shopNowEl.click(shopNowClick);

    responsiveShopNowContent(window);
    window.addEventListener('resize', responsiveShopNowContent);
});
